<template>
  <div class="h-full overflow-hidden flex flex-col">
    <ThreadsNav show-back :show-center="false"> </ThreadsNav>

    <div class="flex-1 overflow-auto border-t flex flex-col">
      <div v-if="loading" class="flex-1 flex items-center justify-center">
        <span class="loading loading-ring"></span>
      </div>
      <div v-else>
        <div class="px-4">
          <div class="red-dot ml-2 flex justify-between items-center mt-2">
            <div>
              <h3 class="text-base font-bold flex items-center">
                {{ $t("treehole.connectWithMe") }}
                <span class="text-sm text-base-content/70">
                  ({{ mateStore.mateLinkList.length }})
                </span>
              </h3>
            </div>
            <div class="flex items-center">
              <button class="btn btn-xs btn-primary" @click="clickImport">
                导入伙伴
              </button>
              <!-- <button
                class="btn btn-xs ml-2 btn-ghost"
                @click="toggleConnectionDetails"
              >
                <svg
                  class="w-4 h-4 transition-transform duration-200"
                  :class="{ 'rotate-180': isConnectionDetailsOpen }"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button> -->
            </div>
          </div>
        </div>

        <div
          class="collapse"
          :class="isConnectionDetailsOpen ? 'collapse-open' : 'collapse-close'"
        >
          <div class="collapse-content">
            <div class="flex flex-col gap-2">
              <div class="flex flex-col text-xs gap-1 ml-2 mb-2">
                <p class="text-base-content/70">
                  {{ $t("treehole.actived") }}：{{
                    mateStore.mateLinkList.filter(
                      (item) => item.targetMate && item.isActive
                    ).length
                  }}
                  人
                </p>
                <p class="text-base-content/70 flex items-center gap-1">
                  <template v-if="!userStore.isFreeModel()">
                    {{ $t("treehole.cost") }}
                    <PowerIcon />
                    {{ userStore.getPowerCostByModel(1) }}
                  </template>
                  <div v-else class="ml-20" />
                  <SelectModelBtn />
                </p>
              </div>
              <MateTreeholeConnectItem
                v-for="item in sortMateLinkList"
                :key="item.id"
                :item="item"
              />
            </div>
          </div>
        </div>

        <!-- <div class="px-4 flex-1 overflow-hidden flex flex-col">
          <div class="red-dot ml-2 flex justify-between items-center my-2">
            <div>
              <h3 class="text-base font-bold">
                {{ $t("treehole.moreRole") }}
              </h3>
            </div>
          </div>

          <div class="flex-1 overflow-auto">
            <div class="flex flex-col gap-2">
              <div
                v-for="item in mateStore.aiMateList"
                :key="item.id"
                class="flex items-center gap-2 bg-base-200 p-2"
                @click="
                  router.push({
                    name: 'mateHome',
                    params: {
                      uuid: item.uuid,
                    },
                    query: {
                      isTreehole: 1,
                    },
                  })
                "
              >
                <MateAvatarNameBioCard
                  show-mock-name
                  :mate="item"
                  avatar-class="w-12"
                  bio-class="line-clamp-2"
                  class="flex-1"
                />
                <button
                  class="btn btn-xs btn-outline"
                  @click.stop="clickConnect(item)"
                >
                  <i class="iconify mingcute--link-line" />
                  {{ $t("treehole.connect") }}
                </button>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onActivated, onMounted, ref } from "vue";
import { useMate } from "@/stores/mate";
import { useUI } from "@/stores/ui";
import { showLoadingToast } from "vant";
import { useI18n } from "vue-i18n";
import { Mate } from "@/types/entity";
import { useRouter } from "vue-router";
import { ThreadListInstance } from "@/components/mobile/ThreadList.vue";
import { PER_PAGE } from "@/stores/moment";
import { useGlobalUser } from "@/stores/globalUser";
const mateStore = useMate();
const uiStore = useUI();
const threadListRef = ref<ThreadListInstance>();
const userStore = useGlobalUser();

const height = ref(0);
const loading = ref(false);
const router = useRouter();
const { t } = useI18n();

// 控制连接详情的展开/收起状态
const isConnectionDetailsOpen = ref(true);

const toggleConnectionDetails = () => {
  isConnectionDetailsOpen.value = !isConnectionDetailsOpen.value;
  if (!isConnectionDetailsOpen.value && mateStore.aiMateList.length === 0) {
    mateStore.fetchAiMateList();
  }
};

const reload = async () => {
  mateStore.aiMateList = [];
  mateStore.aiMatePage = 1;
  threadListRef.value?.resetScrollLoadingState();
};

const sortMateLinkList = computed(() => {
  const list = mateStore.mateLinkList.slice().filter((item) => item.targetMate);

  list.sort((a, b) => {
    if (a.isActive && !b.isActive) return -1;
    if (!a.isActive && b.isActive) return 1;
    return 0;
  });

  return list;
});

const clickImport = () => {
  uiStore.popMateSelector({
    title: t("treehole.selectConnect"),
    exclude: mateStore.mateLinkList.map((item) => item.targetMateId),
    mateOnly: true,
    switchMate: false,
    callback: async (mate) => {
      const loading = showLoadingToast(t(`Message.loading`));
      try {
        await mateStore.createMateLink(mate.id!);
        uiStore.showMateSelector = false;
        loading.close();
      } catch {
        loading.close();
      }
    },
  });
};

const clickConnect = async (item: Mate) => {
  await mateStore.createMateLink(item.id!);
  if (mateStore.aiMateList.length <= PER_PAGE) {
    mateStore.fetchAiMateList();
  }
};

onMounted(() => {
  loading.value = true;
  mateStore.fetchMateLinkList().finally(() => {
    loading.value = false;
  });
});

onActivated(() => {
  if (height.value > 0) {
    threadListRef.value?.scrollTo(height.value);
  }
});
</script>
